import { render, staticRenderFns } from "./Cargo.vue?vue&type=template&id=433c95ce&scoped=true"
import script from "./Cargo.vue?vue&type=script&lang=js"
export * from "./Cargo.vue?vue&type=script&lang=js"
import style0 from "./Cargo.vue?vue&type=style&index=0&id=433c95ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433c95ce",
  null
  
)

export default component.exports